define('app-SearchResults/modules/facets/viewModel',['./settings', 'util', '../../../app-Search/core/service', 'knockout', 'underscore', '../../../app/knockoutExtensions/visibleAnimated'],
        function (settings, util, Service, ko, _) {
            // A little trick to turning escaped HTML into raw HTML.
            function rawHtml(value) {
                return $('<span>' + value + '</span>').text();
            }

            self.checkChildren = function (itm) {
                var enabledChildren = _.filter(itm.collection, function (t) {
                    return t.enabled;
                });

                return enabledChildren.length > 0 ? 'enabled' : 'disabled';
            }

            // Fix for underscore not loading in the view
            ko.bindingHandlers.checkBoxTreeList = {
                init: function (element, valueAccessor) {
                    var data = ko.unwrap(valueAccessor());

                    if ((data.type === 'CheckBoxTreeList' && _.every(data.collection, function (d) { return !d.enabled; })) === false) {
                        $(element).remove();
                    }
                }
            };

            ko.bindingHandlers.radioList = {
                init: function (element, valueAccessor) {
                    var data = ko.unwrap(valueAccessor());

                    if ((data.type === 'RadioList' && _.some(data.collection, function (d) { return d.enabled; })) === false) {
                        $(element).remove();
                    }
                }
            };

            return function (globalSettings) {
                var self = this;
                self.Facets = ko.observableArray([]);
                self.Service = new Service(globalSettings.searchStorageKey);
                self.VisibleSections = ko.observableArray([]);
                self.NoSingleSupplement = ko.observable(false);
                self.DynamicValues = ko.observableArray([]);
                self.FirstLoad = true;
                self.NoSingleSupplementAvailable = ko.observable(true);
                self.Request = 0;
                self.HolidayTypes = ko.observableArray([]);
                self.PassengerNumbers = ko.observableArray([]);
                self.SelectedNumberOfPassengers = ko.observable(2);
                self.CurrentSearchTerms = ko.observable('');
                self.Key = '';
                self.NoUpdate = false;
                self.soldOutCruisesCount = ko.observable();
                self.soldOutCruiseLink = ko.observable();
                

                self.AdditionalFacets = ko.computed(function () {                    
                    var noSingleSupplement = self.NoSingleSupplement();
                    var passengers = self.SelectedNumberOfPassengers();

                    if (self.NoUpdate) return;

                    self.Service.removeTerm({ value: 'True', type: 'so' });
                    self.Service.removeTerm({ value: 'True', type: 'nss' });
                    self.Service.removeAllOfType('p');

                    self.Service.addTerm({
                        name: passengers,
                        type: 'p',
                        description: 'Passengers',
                        value: passengers
                    });                    

                    if (noSingleSupplement) self.Service.addTerm({
                        name: 'NoSingleSupplement',
                        type: 'nss',
                        description: 'No single supplement',
                        value: 'True'
                    });

                    self.Service.Notify();
                }, this);

                self.SelectPassengerNumber = function (passengerNumber) {
                    self.SelectedNumberOfPassengers(passengerNumber.value);
                    $(globalSettings.overallContainer + ' .passengersDropDown').slideUp(120);
                    self.SelectFacet("");

                    util.triggerEvent("search", "selectFacet");

                    AdlAddUpdateItem('filterPassengerNumber', passengerNumber.value);
                    util.satelliteTrack('search results filter');
                };

                self.OpenPassengerDropDown = function () {
                    if ($(globalSettings.overallContainer + ' .passengersDropDown').is(':hidden')) {
                        $(globalSettings.overallContainer + ' .passengersDropDown').slideDown(50);
                    } else {
                        $(globalSettings.overallContainer + ' .passengersDropDown').slideUp(120);
                    }
                };

                // need to create a dictionary for use with the ADL to ensure the correct info goes in, not just the code:
                var facetCodeDict = new Array();
                facetCodeDict["dp"] = "General options|departure point|";
                facetCodeDict["ht"] = "General options|holiday type|";
                facetCodeDict["bb"] = "General options|board basis|";
                facetCodeDict["so"] = "General options|other|";
                facetCodeDict["g"] = "Destination options|destination|";
                facetCodeDict["c"] = "Cruise options|cruise line|";
                facetCodeDict["os"] = "Cruise options|ocean ship|";
                facetCodeDict["rs"] = "Cruise options|river ship|";

                // When a search facet is clicked, update the URL to either remove it or add it.
                self.SelectFacet = function (facet) {
                    AdlAddUpdateItem('filterOption', facetCodeDict[facet.type] + facet.description);
                    util.satelliteTrack('search results filter');

                    //aks - clicking on 'All holidays' - no action needed.
                    if (facet.description == 'All holidays') {
                        return;
                    }

                    if (self.Service.hasTerm(facet)) {
                        self.Service.removeTerm(facet).Notify();
                    } else {
                        self.Service.addTerm(facet).Notify();
                    }
                    
                    resources_setSummaryText();

                    util.triggerEvent("search", "selectFacet");
                    if ($(window).width() < 768) {
                        $('.leftNav').removeClass('popUpFilters').hide();
                        $('.travelMenu').removeClass('closeMenu');
                        $('#searchSummary').show();
                        $('.searchResults, .footer').show();
                    }


                };

                self.SelectExclusiveFacet = function (facet) {
                    AdlAddUpdateItem('filterOption', facetCodeDict[facet.type] + facet.description);
                    util.satelliteTrack('search results filter');

                    // if we're clicking the board basis, update local storage and adobe item
                    if (facet.type === "bb") {
                        localStorage.setItem("boardBasis", facet.description);
                        AdlAddUpdateItem('boardBasis', facet.description);
                    }

                    self.Service.removeAllOfType(facet.type).Notify();
                    if (!facet.selected) {
                        self.Service.addTerm(facet).Notify();
                    }

                    resources_setSummaryText();
                    util.triggerEvent("search", "selectFacet");
                };

                self.ToggleFacetGroup = function (item, e) {
                    // calling this here will fire on each expand / collapse of the facets - but live code is called on load only (at the moment)
                    // var setUpTree = _.debounce(treeScript, 200); // call function to load the tree manipulation -with slight delay
                    // setUpTree();

                    var visibleSections = self.VisibleSections();

                    var g = $(e.target).parents('.accordion-group');

                    if (g.hasClass('active')) {
                        if (item.description === "Trip options") {
                            visibleSections.push(item.description);
                        }                        
                        g.removeClass('active');
                    } else {
                        g.addClass('active');
                    }

                    if (_.contains(visibleSections, item.description)) {
                        visibleSections = _.reject(visibleSections, function (i) {
                            return i === item.description;
                        });
                    }
                    else {
                        visibleSections.push(item.description);
                    }

                    self.VisibleSections(visibleSections);
                };

                self.GetDynamicFacet = ko.computed(function () {
                    var dvalues = self.DynamicValues();
                    // For each dynamic element, see if we have an element in the HTML that matches
                    // and update its text with the value that has been set.
                    _.each(dvalues, function (item) {
                        var element = $(globalSettings.overallContainer + ' ' + settings.container + ' .' + item.name);
                        if (element.length !== 0) {
                            element.text(item.value);
                        }
                    });
                }, this).extend({ throttle: 100 });

                self.ChangeValueSlider = function (value, facetName, unit) {
                    updateService(facetName, value, 'ValueSlider');
                    updateDynamicValues(facetName, rawHtml(value + unit));
                };

                function updateService(facetName, formattedValue, type) {
                    var facet = { name: facetName, value: formattedValue, type: type, description: facetName };
                    self.Service.updateTerm(facet).Notify();
                }

                function updateDynamicValues(facetName, formattedValue) {
                    var dvalues = self.DynamicValues();
                    var dItem = _.find(dvalues, function (item) {
                        return item.name === facetName;
                    });

                    if (!dItem) {
                        dItem = { name: facetName, value: '' };
                        dvalues.push(dItem);
                    }

                    dItem.value = formattedValue;
                    self.DynamicValues(dvalues);
                }

                self.ChangeRangeSlider = function (min, max, facetName, unit) {
                    // If a range slider updates, check to see if we have this facet in the URL and update it.
                    updateService(facetName, min + '-' + max, 'RangeSlider');

                    // Now we need to update an observable so that the user can see the price values they have selected.
                    updateDynamicValues(facetName, rawHtml(unit + min + '-' + unit + max));
                };

                function getSelectedFacetsFromChildren(facets) {
                    if (!facets) return false;

                    if (_.some(facets, function(f) { return f.selected; })) {
                        return true;
                    }

                    for (var i = 0; i < facets.length; i++) {
                        if (getSelectedFacetsFromChildren(facets[i].children)) {
                            return true;
                        }
                    }

                    return false;
                }

                self.hasEnabledItems = function(items) {
                    for (var i = 0; i < items.length; i++) {
                        if (items[i].enabledCount > 0) {
                            return true;
                        }
                    }

                    return false;
                }

                self.GetData = function () {
                    self.NoUpdate = true;

                    self.SelectedNumberOfPassengers((self.Service.getTerm('p') ? ((self.Service.getTerm('p').value == "1") ? self.Service.getTerm('p').value + " passenger" : self.Service.getTerm('p').value + " passengers") : "2 passengers"));

                    var singleSupChecked = _.find(self.Service.allTerms(), function (t) {
                        return t.value === 'True' && t.type === 'nss';
                    });

                    if (singleSupChecked) self.NoSingleSupplement(true);
                    else self.NoSingleSupplement(false);

                    self.Service.getFacets(function (results) {
                        self.Facets([]);
                        var facets = results.facets;
                        self.NoSingleSupplementAvailable(results.noSingleSupplementAvailable);
                        self.PassengerNumbers(results.passengerNumbers);
                        self.HolidayTypes(results.holidayTypes);
                        self.soldOutCruisesCount(results.soldOutCruisesCount);
                        self.soldOutCruiseLink(results.soldOutCruisePageUrl);
                        self.Facets(facets);

                        $('.allFacets').effect({
                            effect: 'highlight',
                            duration: 120,
                            color: '#dbedf9'
                        });

                        var openFacetGroups = _.filter(facets, function (f) {
                            if (f.type === 'CheckBoxTreeList') {
                                return getSelectedFacetsFromChildren(f.collection);
                            } else {
                                return false;
                            }
                        });

                        var openFacetGroupNames = [];
                        _.each(openFacetGroups, function (item) {
                            openFacetGroupNames.push(item.description);
                        });

                        var openAllFacetGroupNames = [];
                        _.each(facets, function (item) {
                            openAllFacetGroupNames.push(item.description);
                        });

                        var setUpTree = _.debounce(treeScript, 200); // call function to load the tree manipulation -with slight delay
                        setUpTree();

                        if (self.FirstLoad) {
                            // If this is the first time on the page, open any appropriate facets.
                            // Other wise, leave it as whatever the user has selected.
                            self.FirstLoad = false;
                            self.VisibleSections([]);
                            if ($(window).width() < 767) {

                            }
                        }
                    });

                    self.NoUpdate = false;
                };

                function constructor() {
                    $(globalSettings.overallContainer + ' .passengersDropDown').hide();
                    self.Key = self.Service.observe(function () {
                        self.CurrentSearchTerms(self.Service.allTerms());
                        self.GetData();
                    });
                };

                constructor();

            };
        });

//general page initialisation 
//and initialize checkboxTree plugin 
function treeScript() {

    if (!$('#searchFacetsCruise').length) {
        // START DATE & DURATION CONTROL - show date and duration controls 
        $('#facetDateAndDuration').show();
        $('#facetDateAndDuration').appendTo('.leftDurationSearch');
        $('#facetDateField').off('focus');

    }
    else {
        var checked = $("#searchFacetsCruise input:checked").length;
        if (checked > 0) {
            $('.filterButton span').html(' (' + checked + ')');
        }
        else {
            $('.filterButton span').html('');
        }
    }
    

    $('.facetChangeTrigger').change(function () {
        var facetDurationValue = $("#facetDuration option:selected").val();
        var facetDurationText = $("#facetDuration option:selected").text();
        var facetDateFieldValue = $('#facetDateField').val();

        updateSearchTags(facetDurationValue, facetDateFieldValue);

        AdlAddUpdateItem('filterTravelDuration', facetDurationText);
        AdlAddUpdateItem('filterTravelDate', facetDateFieldValue);
        //util.satelliteTrack('search results filter');

        resources_setSummaryText();
        if ($(window).width() < 768) {
            $('.leftNav').removeClass('popUpFilters').hide();
            $('.travelMenu').removeClass('closeMenu');
            $('#searchSummary').show();
            $('.searchResults, .footer').show();
        }
        //util.triggerEvent("search", "selectFacet");
        

    });

    //function to remove a value from the json array
    function removeItem(obj, prop, val) {
        var c, found = false;
        for (c in obj) {
            if (obj[c][prop] == val) {
                found = true;
                break;
            }
        }

        if (found) {
            delete obj[c];
        }
    }

    function updateSearchTags(facetDurationValue) {
        var jsonData = "";
        var dates = $('#facetDateField').val();
        var urlEncodedDates = availableDatesDictionary[dates];

        // do the work to update the url (and hash value)
        var data = $(location).attr('hash');

        if (data !== "") {
            var startAt = data.indexOf('[');
            if (startAt >= 0) {
                var endAt = data.lastIndexOf(']');
                compiledSearch = data.substring(startAt, endAt + 1);
                var compiledSearchNew = decodeURIComponent(compiledSearch);
                jsonData = JSON.parse(compiledSearchNew); // app search tags as json
            }
        }

        //call the 'remove' function to remove duration, sd and ed, and replace them with new values
        removeItem(jsonData, 'type', 'du');
        removeItem(jsonData, 'type', 'sd');
        removeItem(jsonData, 'type', 'ed');

        // add the new values
        var dur = decodeURIComponent(facetDurationValue);
        if (dur) jsonData.push(JSON.parse(dur));

        if (typeof urlEncodedDates != "undefined") {
            urlEncodedDates = "[" + urlEncodedDates + "]";
            var objDates = JSON.parse(urlEncodedDates);
            var startDate = objDates[0];
            var endDate = objDates[1];
            if (startDate) jsonData.push(startDate);
            if (endDate) jsonData.push(endDate);
        }

        var strReplacement = JSON.stringify(jsonData);

        var urlPt1 = data.slice(0, startAt);
        var urlPt3 = data.slice(endAt + 1, data.length);
        strReplacement = strReplacement.substring(0, strReplacement.length);
        strReplacement = strReplacement.replace("null,null,null,", "");
        strReplacement = strReplacement.replace("null,null,", "");
        strReplacement = strReplacement.replace("null,", "");
        location.hash = urlPt1 + strReplacement + urlPt3;
    }

    function getSearchTagsForMonths() {
        var jsonData = "";

        var data = $(location).attr('hash');
        if (data != "") {
            var startAt = data.indexOf('[');
            if (startAt >= 0) {
                var endAt = data.lastIndexOf(']');
                compiledSearch = data.substring(startAt, endAt + 1);
                var compiledSearchNew = decodeURIComponent(compiledSearch);

                jsonData = JSON.parse(compiledSearchNew); // app search tags as json
            }
        }

        //call the 'remove' function to remove start date and end date, and replace them with new values
        removeItem(jsonData, 'type', 'sd');
        removeItem(jsonData, 'type', 'ed');

        var strReplacement = JSON.stringify(jsonData);

        strReplacement = strReplacement.substring(0, strReplacement.length);
        strReplacement = strReplacement.replace("null,null,null,", "");
        strReplacement = strReplacement.replace("null,null,", "");
        strReplacement = strReplacement.replace("null,", "");

        //return the string in the format taken in by showDatePicker
        return strReplacement.substring(1, strReplacement.length - 1);
    }

    $('#facetDateField').off('focus');

    $('#facetDateField').focus(function (e) {
        showDatePicker('#facetDateField', getSearchTagsForMonths());
        $(this).next().slideToggle();
        $(this).blur();
    });

    // END DATE & DURATION CONTROL - move and show date and duration controls

    // first H4 has a top border when it shouldn't have - remove it here
    $(".accordion-inner > h4:first-child").css("border-top", "none");

    // Departure Points
    var departurePoints = $(".noreportedresults", "#Departure_points");
    if (departurePoints.length === 0) {
        departurePoints = $(".noreportedresults", "#Departure_ports");
    }

    departurePoints.siblings("label").css("font-weight", "bold").addClass("killed_link");
    departurePoints.css("display", "none");
    departurePoints.siblings("ul").not(":has(label)").parent().css("display", "none");

    $(".moreOptionsDiv").on("click", function () {
        var $this = $(this);
        var parent = $this.parent();

        if ($this.text() == "more options") {
            $this.text("fewer options").append('<span class="glyphicon glyphicon-chevron-up" />');
            parent.find("li").show();
        } else {
            $this.text("more options").append('<span class="glyphicon glyphicon-chevron-down" />');
            parent.find("li").filter(function () { return $(this).text() !== ""; }).slice(7).hide();
        }
    });

    // limit each section height
    $(".limitedHeightList").each(function () {
        var $this = $(this);
        var count = $this.data("count");

        if (count <= 0) {
            $this.addClass("d-none");
        } else if (count > 8) {

            $this.find(".moreOptionsDiv").removeClass("d-none");
            $this.find("li").filter( function() { return $(this).text() !== ""; }).slice(7).hide();
        }
    });

    // hide any empty groups
    $('.accordion-group .disabled').addClass('d-none');

    // adds class to accordion group 
    $('.accordion-inner').parent().parent().addClass("do_not_hide");

    //accordion groups without do_not_hide class need to be hidden!
    $(".accordion-group:not(.do_not_hide)").addClass("d-none");

    // open 'Trip options' accordian for desktop and close for mobile devices
    if ($("#filterResults").is(":hidden")) {
        var tripOptions = $("a span:contains('Trip options')").parents(".accordion-group");
        tripOptions.addClass("active");
        tripOptions.find(".accordion-body").show();
    }
};
